import { EpimsBaseEntityDto } from './epim-base.dto';
export class YearOfSuitDto extends EpimsBaseEntityDto {
  YearOfSuitName: string;
  SubscriptionUserId: string;
  Version: number;
}
